/* Tienda Flashs - calculadora con deslizador (tf-lp-slider). Sin JS se ve el resultado del valor inicial. Sin dependencias. */
(function () {
  function num(v) { return parseFloat(String(v || '').replace(',', '.')); }
  function fmt(n, dec) { return n.toFixed(dec).replace('.', ','); }

  function init(sec) {
    if (sec.__tfSlider) return;
    sec.__tfSlider = true;
    var input = sec.querySelector('input[type="range"]');
    var out = sec.querySelector('[data-out]');
    var val = sec.querySelector('[data-value]');
    var unitEl = sec.querySelector('[data-unit-text]');
    if (!input || !out) return;
    var mode = sec.getAttribute('data-mode');
    var a = num(sec.getAttribute('data-a')), b = num(sec.getAttribute('data-b'));
    var rate = num(sec.getAttribute('data-rate')) || 1;
    var dec = parseInt(sec.getAttribute('data-decimals'), 10) || 0;
    var tpl = sec.getAttribute('data-result') || '';
    var unit = sec.getAttribute('data-unit') || '', unitOne = sec.getAttribute('data-unit-one') || unit;

    function update() {
      var x = num(input.value);
      var u = x === 1 ? unitOne : unit;
      var min = num(input.min), max = num(input.max);
      input.style.setProperty('--tf-sl-fill', ((x - min) / ((max - min) || 1) * 100) + '%');
      input.setAttribute('aria-valuetext', input.value + ' ' + u);
      if (val) val.textContent = input.value;
      if (unitEl) unitEl.textContent = u;
      var txt;
      if (mode === 'division') {
        txt = tpl.replace('[r]', fmt(x / rate, dec));
      } else {
        txt = tpl.replace('[min]', Math.floor(a / x)).replace('[max]', Math.floor(b / x));
      }
      out.textContent = txt;
    }
    input.addEventListener('input', update);
    update();
  }

  function run(scope) {
    (scope || document).querySelectorAll('[data-tf-slider]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
